// on-demand-preload.strategy.ts
import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class OnDemandPreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    // Проверяем флаг route.data?.['preload']
    if (route.data && route.data['preload']) {
      // Допустим, ждем 5 секунд, чтобы дать странице основательно загрузиться
      return timer(5000).pipe(mergeMap(() => load()));
    } else {
      return of(null);
    }
  }
}
